export const product = `
  id
  title
  handle
  onlineStoreUrl
  tags
  priceRange {
    minVariantPrice {
      amount
      currencyCode
    }
  }
  compareAtPriceRange {
    minVariantPrice {
      amount
      currencyCode
    }
  }
  fabricName: metafield(namespace: "custom", key: "fabric_name") {
    value
  }
  swatchImage: metafield(namespace: "custom", key: "swatch_image") {
    reference {
      ... on MediaImage {
        image {
          url
        }
      }
    }
  }
  badgeNew: metafield(namespace: "custom", key: "badge_new") {
    value
  }
  badgeCustom: metafield(namespace: "custom", key: "badge_custom") {
    value
  }
  options {
    name
    values
  }
  variants(first: 50) {
    edges {
      node {
        id
        title
        availableForSale
        price {
          amount
        }
        selectedOptions {
          name
          value
        }
      }
    }
  }
  media(first: 2) {
    edges {
      node {
        previewImage {
          url
        }
      }
    }
  }
`;
